"use strict";
/**
 * Post an accounting ledger entry for **absorbed credit card / transaction markup**.
 *
 * ## Trigger
 * When Nucleus releases an escrow payment and the business chose to absorb the CC/transaction fee
 * (i.e. not passed to the client).
 *
 * ## Idempotency
 * `project_invoice_cc_fee:{projectInvoiceId}:{suffix}` — one ledger entry per release event.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_ABSORBED_CC_FEE_LEDGER_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_POST_ABSORBED_CC_FEE_LEDGER = void 0;
exports.parseProjectInvoiceCcFeeIdempotencyKey = parseProjectInvoiceCcFeeIdempotencyKey;
exports.buildAccountingAbsorbedCcFeeIdempotencyKey = buildAccountingAbsorbedCcFeeIdempotencyKey;
exports.computeAbsorbedCcFeeAmount = computeAbsorbedCcFeeAmount;
exports.isPostAbsorbedCcFeeLedgerAccountingSyncOp = isPostAbsorbedCcFeeLedgerAccountingSyncOp;
exports.ACCOUNTING_SYNC_OPERATION_POST_ABSORBED_CC_FEE_LEDGER = "POST_ABSORBED_CC_FEE_LEDGER";
exports.ACCOUNTING_ABSORBED_CC_FEE_LEDGER_SYNC_IDEMPOTENCY_PREFIX = "project_invoice_cc_fee:";
const PROJECT_INVOICE_CC_FEE_KEY_UUID = /^project_invoice_cc_fee:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(.+)$/i;
function parseProjectInvoiceCcFeeIdempotencyKey(idempotencyKey) {
    const match = idempotencyKey.match(PROJECT_INVOICE_CC_FEE_KEY_UUID);
    if (!match)
        return null;
    return { projectInvoiceId: match[1], idempotencySuffix: match[2] };
}
function buildAccountingAbsorbedCcFeeIdempotencyKey(projectInvoiceId, idempotencySuffix) {
    return `${exports.ACCOUNTING_ABSORBED_CC_FEE_LEDGER_SYNC_IDEMPOTENCY_PREFIX}${projectInvoiceId}:${idempotencySuffix}`;
}
/**
 * Pure helper: absorbed CC fee amount = (businessRevenue + handshakeFee) * ccFeePercentageDecimal.
 * Caller is responsible for deciding whether the business is actually absorbing.
 */
function computeAbsorbedCcFeeAmount(params) {
    const releaseBase = (params.businessRevenueAmount ?? 0) + (params.handshakeFeeAmount ?? 0);
    const raw = releaseBase * (params.ccFeePercentageDecimal ?? 0);
    return Math.round(raw * 100) / 100;
}
function isPostAbsorbedCcFeeLedgerAccountingSyncOp(operation) {
    return operation === exports.ACCOUNTING_SYNC_OPERATION_POST_ABSORBED_CC_FEE_LEDGER;
}
